import React from "react";
import { useTranslation } from "react-i18next";
import { BookingActionContext } from "../../../services/bookingActionService";

interface BookingDetailsCardProps {
  booking: BookingActionContext;
}

const BookingDetailsCard: React.FC<BookingDetailsCardProps> = ({ booking }) => {
  const { t, i18n } = useTranslation('booking');

  const formatDateTime = (date: Date) => {
    const locale = i18n.language || 'en';
    const isJapanese = locale === 'ja';

    return date.toLocaleString(locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: !isJapanese, // 24-hour for Japanese, 12-hour for English
      timeZoneName: 'short',
    });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="p-4 sm:p-6">
        <div className="space-y-4">
          {/* Meeting Title */}
          <div>
            <dt className="text-sm font-medium text-gray-500">{t('cancel.details.meeting')}</dt>
            <dd className="text-sm sm:text-base text-gray-900 mt-1 font-medium">
              {booking.title || booking.meetingType.title}
            </dd>
          </div>

          {/* Date & Time - includes timezone in the formatted output */}
          <div>
            <dt className="text-sm font-medium text-gray-500">{t('cancel.details.dateTime')}</dt>
            <dd className="text-sm sm:text-base text-gray-900 mt-1">
              {formatDateTime(booking.startTime)}
            </dd>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingDetailsCard;